<template>
  <div class='EnbLogin'
  :style="{
    backgroundColor: Prefes.lojaCorFundo.corBackground
  }"
  >
    <enb-top/>
    <div class="label">Informe suas credenciais abaixo</div>
    <div class="cont-input">
      <enb-input @update:modelValue="value => login = value" label="Email" :input="{ width: '65%' }"/>
    </div>
    <div class="cont-input">
      <enb-input @update:modelValue="value => senha = value" label="Senha" type="password" :input="{ width: '65%' }"/>
    </div>
    <div class="cont-btn">
      <div class="text-link">
        <span style="cursor: pointer" @click="$router.push('/pwrecovery')">
          Esqueci a senha
        </span>
      </div>
      <div class="btn">
        <enb-button label="entrar" @click="Login"/>
      </div>
    </div>
    <div class="cont-msg">{{ msg }}</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EnbTop from './EnbTop'
import EnbInput from '../EnbInput'
import EnbButton from '../EnbButton'
export default {
  name: 'EnbLogin',
  components: { EnbTop, EnbInput, EnbButton },
  data () {
    return {
      login: '',
      senha: '',
      msg: ''
    }
  },
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['GetLogin', 'SetModal01']),
    Login () {
      this.GetLogin({ login: this.login, senha: this.senha })
        .then(res => {
          if(res.user === null) {
            if(res.code !== null && res.code === 537) {
              window.location.replace('https://enegocios.online/atualizar-sistema/')
              return
            }
            this.msg = res.message
            return
          }
          //lojista: primeiro login vai para as preferências
          if(res.user.tipo === 'a') {
            this.$router.push(res.user.logincount ? '/painel' : '/painel/preference')
          }
          else {
            this.$router.push('/profile')
          }
          // document.getElementById('content').scrollIntoView({ 
          //   behavior: "smooth",
          //   block: "start"
          // })
          this.SetModal01({ active: false })
        })
    }
  }
}
</script>

<style scoped>
.EnbLogin {
  width: 25%;
  height: 53%;
  position: absolute;
  margin: auto;
  background-color: orange;
  border-radius: 8px;
}

.label {
  color: #333333;
  font-size: 17px;
}

.cont-input {
  margin-top: 10%;
}

.cont-btn {
  width: 60%;
  padding: 15%;
  padding-bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
}

.cont-msg {
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-link {
  width: 50%;
  text-align: left;
  font-size: 12px;
}

.btn {
  width: 50%;
  text-align: right
}

@media (max-width: 500px) {
  .EnbLogin {
    width: 90%;
    height: 65%;
  }
}
</style>
